import { render, staticRenderFns } from "./modal-search-product.vue?vue&type=template&id=24021b29&scoped=true"
import script from "./modal-search-product.vue?vue&type=script&lang=js"
export * from "./modal-search-product.vue?vue&type=script&lang=js"
import style0 from "./modal-search-product.vue?vue&type=style&index=0&id=24021b29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24021b29",
  null
  
)

export default component.exports